import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import "./Manualorders.scss";
import { EXCHNAGE_URL } from "../../../../Url/Url";

const Manualorders = () => {
  const token = localStorage.getItem("token");
  const eventIdGet = useSelector((state) => state?.users?.id);
  const eventId = String(eventIdGet);
  const [loading, setLoading] = useState(false);
  const [submissions, setSubmissions] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [updatingId, setUpdatingId] = useState(null);

  const getManualPayments = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${EXCHNAGE_URL}/manual-payment-history/${eventId}`,
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setSubmissions(response.data.data || []);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to load payment history");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getManualPayments();
  }, []);

  const updatePaymentStatus = async (submissionId) => {
    try {
      setUpdatingId(submissionId);
      const response = await axios.put(
        `${EXCHNAGE_URL}/submission/payment-status`,
        {
          submissionId,
        },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        toast.success("Payment marked as paid successfully!");
        getManualPayments();
      }
    } catch (error) {
      toast.error("Failed to update payment status");
    } finally {
      setUpdatingId(null);
    }
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      paid: "status-badge status-paid",
      pending: "status-badge status-pending",
      failed: "status-badge status-failed",
      refunded: "status-badge status-refunded",
    };
    return statusMap[status?.toLowerCase()] || "status-badge";
  };

  const filteredData = submissions.filter((item) => {
    const matchesSearch = item.submission_id
      .toLowerCase()
      .includes(search.toLowerCase());
    const matchesStatus =
      selectedStatus === "all" || item.payment_status?.toLowerCase() === selectedStatus;
    return matchesSearch && matchesStatus;
  });

  const pendingCount = submissions.filter(
    (item) => item.payment_status?.toLowerCase() === "pending"
  ).length;

  return (
    <div className="manual-payment-page">
      <div className="manual-header">
        <div className="header-left">
          <h2>
            <i className="fas fa-hand-holding-usd"></i> Manual Payments
          </h2>
          <span className="payment-count">{submissions.length} total</span>
        </div>

        <div className="header-right">
          <div className="filter-group">
            <select
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              className="status-filter"
            >
              <option value="all">All Status</option>
              <option value="pending">Pending ({pendingCount})</option>
              <option value="paid">Paid</option>
              <option value="failed">Failed</option>
              <option value="refunded">Refunded</option>
            </select>

            <div className="search-wrapper">
              <i className="fas fa-search search-icon"></i>
              <input
                type="text"
                placeholder="Search by Submission ID..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="search-input"
              />
              {search && (
                <button
                  className="clear-search"
                  onClick={() => setSearch("")}
                >
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </div>

          <button
            className="refresh-btn"
            onClick={getManualPayments}
            disabled={loading}
          >
            <i className={`fas fa-sync-alt ${loading ? "fa-spin" : ""}`}></i>
          </button>
        </div>
      </div>

      <div className="manual-table-wrapper">
        <table className="manual-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Submission ID</th>
              <th>Status</th>
              <th>Remarks</th>
              <th>Created By</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6">
                  <div className="loading-state">
                    <i className="fas fa-spinner fa-spin"></i>
                    <span>Loading payment history...</span>
                  </div>
                </td>
              </tr>
            ) : filteredData.length === 0 ? (
              <tr>
                <td colSpan="6">
                  <div className="empty-state">
                    <i className="fas fa-inbox"></i>
                    <p>No payment history found</p>
                    <span>Try adjusting your search or filters</span>
                  </div>
                </td>
              </tr>
            ) : (
              filteredData.map((item, index) => (
                <tr key={item.id}>
                  <td className="row-number">{index + 1}</td>
                  <td className="submission-id">
                    <span className="id-badge">{item.submission_id}</span>
                  </td>
                  <td>
                    <span className={getStatusBadge(item.payment_status)}>
                      <i
                        className={`fas fa-${
                          item.payment_status?.toLowerCase() === "paid"
                            ? "check-circle"
                            : item.payment_status?.toLowerCase() === "pending"
                            ? "clock"
                            : item.payment_status?.toLowerCase() === "failed"
                            ? "times-circle"
                            : "info-circle"
                        }`}
                      ></i>
                      {item.payment_status || "Pending"}
                    </span>
                  </td>
                  <td>{item.remarks || "-"}</td>
                  <td>
                    <span className="created-by">
                      <i className="fas fa-user-circle"></i>
                      Admin
                    </span>
                  </td>
                  <td>
                    {item.payment_status?.toLowerCase() !== "paid" && (
                      <button
                        className="mark-paid-btn"
                        onClick={() => updatePaymentStatus(item.id)}
                        disabled={updatingId === item.id}
                      >
                        {updatingId === item.id ? (
                          <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                          <>
                            <i className="fas fa-check"></i> Mark Paid
                          </>
                        )}
                      </button>
                    )}
                    {item.payment_status?.toLowerCase() === "paid" && (
                      <span className="already-paid">
                        <i className="fas fa-check-circle"></i> Completed
                      </span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {filteredData.length > 0 && (
          <div className="table-footer">
            <span>
              Showing {filteredData.length} of {submissions.length} entries
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Manualorders;